import AirshipEventsTable from "./AirshipEventsTable";

export default AirshipEventsTable;
